export default "__VITE_ASSET__CFe83t8U__"